import { FC } from 'react'
import Image from 'next/image'

import {
  coupleBeach,
  speechBubbleTail,
  bankIcon,
  checkmarkIcon,
} from '@ui/assets'

export const InstantCash: FC = () => {
  return (
    <section
      id="access-cash"
      className="relative scroll-mt-20 bg-[#daf1fa] py-24"
    >
      {/* Star decoration */}
      <div className="absolute right-8 top-[200px] z-10 h-16 w-16 lg:right-16 lg:top-1/2 lg:-translate-y-1/2">
        <svg
          viewBox="0 0 55 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-full w-full"
        >
          <path
            d="M23.3789 9.70879L27.5977 31.0818M27.5977 31.0818L29.6016 52.4549M27.5977 31.0818L0.914067 34.3457M27.5977 31.0818L54.9141 32.5558M27.5977 31.0818L52.5937 0.970055M27.5977 31.0818L53.2266 61.72M27.5977 31.0818L12.7266 53.7183M27.5977 31.0818L0.914067 10.9722"
            stroke="#29bfed"
            strokeWidth="3.0375"
          />
        </svg>
      </div>

      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-16 md:grid md:grid-cols-2 md:items-center">
          <div className="relative order-1 h-[400px] md:order-2 md:h-[480px]">
            {/* Circular couple photo */}
            <div className="absolute left-1/2 top-1/2 z-0 h-[350px] w-[300px] -translate-x-1/2 -translate-y-1/2 md:left-auto md:right-0 md:top-1/2 md:h-[420px] md:w-[350px] md:-translate-y-1/2 md:translate-x-0">
              <div className="flex h-full w-full rotate-[30deg] items-center justify-center">
                <Image
                  src={coupleBeach}
                  width={350}
                  height={420}
                  alt="Happy couple"
                  className="rounded-full object-cover"
                />
              </div>
            </div>

            {/* Chat bubble overlay */}
            <div className="relative z-10">
              <div className="absolute left-4 top-8 rounded-[52px] bg-[#006fff] px-3 py-2 md:left-0 md:px-4 md:py-3">
                <p className="font-display text-[12px] uppercase tracking-[-0.24px] text-[#f2f2f0] md:text-[16.5px] md:tracking-[-0.33px]">
                  WHAT SHOULD I DO WITH THIS EXTRA $100?
                </p>
              </div>
              {/* Speech bubble tail - bottom left, extends downward */}
              <div className="absolute left-[23px] top-[calc(2rem+28px)] md:left-[19px] md:top-[calc(2rem+40px)]">
                <Image
                  src={speechBubbleTail}
                  width={22}
                  height={22}
                  alt=""
                  className="h-4 w-4 md:h-[22px] md:w-[22px]"
                />
              </div>
            </div>

            {/* Rewards card */}
            <div className="absolute bottom-[-20px] right-4 z-20 w-[200px] scale-90 rounded-2xl bg-white p-4 shadow-[0px_4px_0px_0px_rgba(10,45,74,0.1)] md:bottom-[-27px] md:right-[-75px] md:w-[282px] md:scale-100 md:p-6">
              <div className="mb-3 flex items-center justify-between lg:mb-4">
                <p className="font-display text-[14px] tracking-[-0.42px] text-[#0a3754] lg:text-[18px] lg:tracking-[-0.54px]">
                  Rewards
                </p>
                <Image
                  src={bankIcon}
                  width={20}
                  height={20}
                  alt=""
                  className="lg:h-6 lg:w-6"
                />
              </div>
              <div className="mb-4 h-px bg-[rgba(10,55,84,0.1)] lg:mb-6" />
              <p className="font-display text-[42px] uppercase tracking-[-1.26px] text-[#29bfed] lg:text-[62px] lg:tracking-[-1.86px]">
                $1,348
              </p>
            </div>
          </div>

          <div className="order-2 max-w-[480px] lg:order-1">
            <h2 className="font-display mb-8 text-4xl leading-none tracking-[-1.52px] text-[#0a2d4a] md:text-5xl lg:text-[52px]">
              Instant Cash
              <br className="lg:hidden" />{' '}
              <span className="text-[#29bfed]">Advances</span>
            </h2>
            <p className="mb-8 max-w-[400px] text-[17px] leading-[1.4] text-[#0a2d4a]">
              Access cash quickly when unexpected expenses arise. No interest.
              No credit check. We're not a bank or a lender—just a smarter way
              to manage your finances.
            </p>

            <div className="space-y-5">
              <div className="flex items-center gap-3 border-b border-[rgba(10,45,74,0.1)] pb-5">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Track your spending and boost your savings
                </p>
              </div>

              <div className="flex items-center gap-3 border-b border-[rgba(10,45,74,0.1)] pb-5">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Get Cash Straight to Your Bank
                </p>
              </div>

              <div className="flex items-center gap-3">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Avoid Overdraft Fees
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
